export default {
	"AtInteceptModal.YouHaveNotSavedYourShippingAddressInformationPleaseSaveItAndThenLeaveSoThatTheSystemCanHelpYouArrangeTheShipmentAsSoonAsPossible": "您还未保存您的收货地址信息，请保存后再离开以便系统尽快帮您安排发货",
	"AtInteceptModal.return": "返回"
}